import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import classNames from 'classnames/bind';
import { Carousel } from 'react-responsive-carousel';
import stylesCarousel from 'react-responsive-carousel/lib/styles/carousel.min.css';

import { ImageTechDoc } from 'components/ImageTechDoc';
import ResponsiveImage from 'components/ResponsiveImage';

import styles from './ProductCarousel.module.scss';
const cx = classNames.bind(styles, stylesCarousel);

const settings = {
  showThumbs: false,
  showArrows: false,
  showStatus: false,
  centerMode: true,
  centerSlidePercentage: 92,
};

const ProductCarousel = ({ data, alt }) => (
  <div className={cx('root')}>
    <Carousel {...settings}>
      {data.map((item) => (
        <ResponsiveImage className={cx('carousel-item')} key={item.thumbDocId}>
          <div className={cx('item-image')}>
            <ImageTechDoc id={item.thumbDocId} alt={alt} />
          </div>
        </ResponsiveImage>
      ))}
    </Carousel>
  </div>
);

ProductCarousel.propTypes = {
  data: arrayOf(
    shape({
      thumbDocId: string.isRequired,
    })
  ).isRequired,
  alt: string,
};

ProductCarousel.defaultProps = {
  alt: '',
};

export default ProductCarousel;



// WEBPACK FOOTER //
// ./src/pages/Product/components/ProductCarousel/ProductCarousel.js